module.exports = __webpack_public_path__ + "static/img/fish48.cd3a587.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish48.png
// module id = v6El
// module chunks = 0